import { createSlice } from '@reduxjs/toolkit';
import NetworkError from 'shared/exceptions/network';
import { ShopSchema } from '../types/shopSchema';
import { fetchBuyShopItem, fetchShopItems } from '../services/fetchShop';

const initialState: ShopSchema = {
  shop: {
    loading: false,
  },
  buy: {
    loading: false,
    dialogOpen: false,
    isBuying: false,
  },
};

export const shopSlice = createSlice({
  name: 'shop',
  initialState,
  reducers: {
    onOpenDialog(state) {
      state.buy.dialogOpen = true;
    },
    onCloseDialog(state) {
      state.buy.dialogOpen = false;
      state.buy.isBuying = false;
      state.buy.error = undefined;
    },
  },
  extraReducers: builder => {
    // shop/fetchShopItems
    builder
      .addCase(fetchShopItems.pending, state => {
        state.shop.loading = true;
        state.shop.error = undefined;
      })
      .addCase(fetchShopItems.fulfilled, (state, action) => {
        state.shop.loading = false;
        state.shop.error = undefined;
        state.shop.items = action.payload.data.data;
      })
      .addCase(fetchShopItems.rejected, (state, action) => {
        state.shop.loading = false;
        const message = (action.payload as NetworkError).message;
        state.shop.error = {
          ...(action.payload as NetworkError),
          message,
        };
      });

    // shop/fetchBuyShopItem
    builder
      .addCase(fetchBuyShopItem.pending, state => {
        state.buy.loading = true;
        state.buy.error = undefined;
      })
      .addCase(fetchBuyShopItem.fulfilled, state => {
        state.buy.loading = false;
        state.buy.error = undefined;
        state.buy.isBuying = true;
        // state.buy.dialogOpen = false;
      })
      .addCase(fetchBuyShopItem.rejected, (state, action) => {
        state.buy.loading = false;
        const message = (action.payload as NetworkError).message;
        state.buy.error = {
          ...(action.payload as NetworkError),
          message,
        };
      });
  },
});

export const { actions: shopActions } = shopSlice;
export const { reducer: shopReducer } = shopSlice;
